export default () => {
    /**
    * Set class when header is fixed
    * @param {*} ev
    */
    // submenu_hover();
    body_bg_hover();
}

/**
 * Add background overlay to body element on desktop menu hover
 */
function body_bg_hover(){
  let desktopMenu = document.querySelectorAll("header nav");
  let main = document.getElementById("main");
  if (desktopMenu.length > 0) {
    desktopMenu[0].addEventListener('mouseenter', () => {
      main.classList.add('dark');
    });
    desktopMenu[0].addEventListener('mouseleave', () => {
      main.classList.remove('dark');
    });
  }
}

/**
 * Manage submenu showing on its parent hover to behave like a tab
 */
function submenu_hover(){
  document.querySelectorAll('.Menu__Item.has_children .Menu__Item.has_children').forEach((el) => {
    el.addEventListener('mouseover', (ev) => {
      let siblings = getSiblings(ev.target);
      if(siblings){
        siblings.forEach((sibling) => {
          sibling.classList.add('submenu-hidden');
        });
      }
      ev.target.classList.remove('submenu-hidden');
    });
    el.querySelector('a').addEventListener('mouseover', (ev) => {
      const mouseoverEvent = new Event('mouseover');
      ev.target.parentNode.dispatchEvent(mouseoverEvent);
    });
  });
}

/**
 * Get siblings of an element
 * @returns {Array}
 * @param e
 */
function getSiblings(e) {
  let siblings = [];
  if(!e.parentNode) {
    return siblings;
  }
  let sibling  = e.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
}

